import { useState } from "react"
import { Button, Container, Form, Modal, Spinner } from "react-bootstrap"
import { FaPrint } from "react-icons/fa"

enum PrintMode {
  REPORTS = "REPORTS",
  RECORDS = "RECORDS"
}

interface PrintFormModalProps {
  disabled: boolean
  hasReports: boolean
  printing: boolean
  onPrintRecords: () => void
  onPrintReports: () => void
}

const PrintFormModal = (props: PrintFormModalProps) => {
  const [printMode, setPrintMode] = useState<PrintMode>(PrintMode.REPORTS)
  const [showPrintModal, setShowPrintModal] = useState<boolean>(false)
  const { disabled, printing, hasReports, onPrintRecords } = props

  const showPrintForm = () => hasReports ? setShowPrintModal(true) : onPrintRecords()

  const hidePrintForm = () => setShowPrintModal(false)

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => setPrintMode(e.target.value as PrintMode)

  const onPrint = (): void => {
    switch (printMode) {
      case PrintMode.RECORDS:
        props.onPrintRecords()
        break
      case PrintMode.REPORTS:
        props.onPrintReports()
        break
    }
    hidePrintForm()
  }

  return (
    <>
      <Button variant="secondary" size="sm" onClick={() => showPrintForm()} className="float-right" disabled={disabled || printing}>
        {printing && <Spinner animation="border" size="sm" />}
        {!printing && <FaPrint />}
      </Button>
      <Modal show={showPrintModal} onHide={() => hidePrintForm()} dialogClassName="dark">
        <Modal.Header closeButton>
          <Modal.Title>
            CHOOSE OPTION
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3">
          <Container fluid>
            <Form.Check id="reports" name="print" type="radio" label="Print Result Reports" value={PrintMode.REPORTS} checked={printMode === PrintMode.REPORTS} className="abc-radio" onChange={(e) => onChange(e)} />
            <Form.Check id="records" name="print" type="radio" label="Print Records" value={PrintMode.RECORDS} checked={printMode === PrintMode.RECORDS} className="abc-radio mt-2" onChange={(e) => onChange(e)} />
          </Container>
        </Modal.Body>
        <Modal.Footer className="button-block">
          <Button variant="primary" size="sm" onClick={() => onPrint()}>CONTINUE</Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
export default PrintFormModal
